import { RAG_ACTION_TYPES } from "../actions/ragActions";

const initialState = {
  // Process Document
  processDocumentLoading: false,
  processDocumentData: null,
  processDocumentError: null,

  // Query RAG
  queryRAGLoading: false,
  queryRAGData: null,
  queryRAGError: null,

  // Get Document
  getDocumentLoading: false,
  getDocumentData: null,
  getDocumentError: null,

  // List Documents
  listDocumentsLoading: false,
  listDocumentsData: [],
  listDocumentsError: null,

  // Get Document Chunks
  getDocumentChunksLoading: false,
  getDocumentChunksData: [],
  getDocumentChunksError: null,

  // Get RAG Stats
  getRAGStatsLoading: false,
  getRAGStatsData: null,
  getRAGStatsError: null,

  // Update Document
  updateDocumentLoading: false,
  updateDocumentData: null,
  updateDocumentError: null,

  // Delete Document
  deleteDocumentLoading: false,
  deleteDocumentData: null,
  deleteDocumentError: null,
};

const ragReducer = (state = initialState, action) => {
  switch (action.type) {
    // Process Document
    case RAG_ACTION_TYPES.PROCESS_DOCUMENT_REQUEST:
      return {
        ...state,
        processDocumentLoading: true,
        processDocumentError: null,
      };
    case RAG_ACTION_TYPES.PROCESS_DOCUMENT_SUCCESS:
      return {
        ...state,
        processDocumentLoading: false,
        processDocumentData: action.payload,
        processDocumentError: null,
      };
    case RAG_ACTION_TYPES.PROCESS_DOCUMENT_FAILURE:
      return {
        ...state,
        processDocumentLoading: false,
        processDocumentError: action.payload,
      };

    // Query RAG
    case RAG_ACTION_TYPES.QUERY_RAG_REQUEST:
      return {
        ...state,
        queryRAGLoading: true,
        queryRAGError: null,
      };
    case RAG_ACTION_TYPES.QUERY_RAG_SUCCESS:
      return {
        ...state,
        queryRAGLoading: false,
        queryRAGData: action.payload,
        queryRAGError: null,
      };
    case RAG_ACTION_TYPES.QUERY_RAG_FAILURE:
      return {
        ...state,
        queryRAGLoading: false,
        queryRAGError: action.payload,
      };

    // Get Document
    case RAG_ACTION_TYPES.GET_DOCUMENT_REQUEST:
      return {
        ...state,
        getDocumentLoading: true,
        getDocumentError: null,
      };
    case RAG_ACTION_TYPES.GET_DOCUMENT_SUCCESS:
      return {
        ...state,
        getDocumentLoading: false,
        getDocumentData: action.payload,
        getDocumentError: null,
      };
    case RAG_ACTION_TYPES.GET_DOCUMENT_FAILURE:
      return {
        ...state,
        getDocumentLoading: false,
        getDocumentError: action.payload,
      };

    // List Documents
    case RAG_ACTION_TYPES.LIST_DOCUMENTS_REQUEST:
      return {
        ...state,
        listDocumentsLoading: true,
        listDocumentsError: null,
      };
    case RAG_ACTION_TYPES.LIST_DOCUMENTS_SUCCESS:
      return {
        ...state,
        listDocumentsLoading: false,
        listDocumentsData: action.payload,
        listDocumentsError: null,
      };
    case RAG_ACTION_TYPES.LIST_DOCUMENTS_FAILURE:
      return {
        ...state,
        listDocumentsLoading: false,
        listDocumentsError: action.payload,
      };

    // Get Document Chunks
    case RAG_ACTION_TYPES.GET_DOCUMENT_CHUNKS_REQUEST:
      return {
        ...state,
        getDocumentChunksLoading: true,
        getDocumentChunksError: null,
      };
    case RAG_ACTION_TYPES.GET_DOCUMENT_CHUNKS_SUCCESS:
      return {
        ...state,
        getDocumentChunksLoading: false,
        getDocumentChunksData: action.payload,
        getDocumentChunksError: null,
      };
    case RAG_ACTION_TYPES.GET_DOCUMENT_CHUNKS_FAILURE:
      return {
        ...state,
        getDocumentChunksLoading: false,
        getDocumentChunksError: action.payload,
      };

    // Get RAG Stats
    case RAG_ACTION_TYPES.GET_RAG_STATS_REQUEST:
      return {
        ...state,
        getRAGStatsLoading: true,
        getRAGStatsError: null,
      };
    case RAG_ACTION_TYPES.GET_RAG_STATS_SUCCESS:
      return {
        ...state,
        getRAGStatsLoading: false,
        getRAGStatsData: action.payload,
        getRAGStatsError: null,
      };
    case RAG_ACTION_TYPES.GET_RAG_STATS_FAILURE:
      return {
        ...state,
        getRAGStatsLoading: false,
        getRAGStatsError: action.payload,
      };

    // Update Document
    case RAG_ACTION_TYPES.UPDATE_DOCUMENT_REQUEST:
      return {
        ...state,
        updateDocumentLoading: true,
        updateDocumentError: null,
      };
    case RAG_ACTION_TYPES.UPDATE_DOCUMENT_SUCCESS:
      return {
        ...state,
        updateDocumentLoading: false,
        updateDocumentData: action.payload,
        updateDocumentError: null,
      };
    case RAG_ACTION_TYPES.UPDATE_DOCUMENT_FAILURE:
      return {
        ...state,
        updateDocumentLoading: false,
        updateDocumentError: action.payload,
      };

    // Delete Document
    case RAG_ACTION_TYPES.DELETE_DOCUMENT_REQUEST:
      return {
        ...state,
        deleteDocumentLoading: true,
        deleteDocumentError: null,
      };
    case RAG_ACTION_TYPES.DELETE_DOCUMENT_SUCCESS:
      return {
        ...state,
        deleteDocumentLoading: false,
        deleteDocumentData: action.payload,
        deleteDocumentError: null,
      };
    case RAG_ACTION_TYPES.DELETE_DOCUMENT_FAILURE:
      return {
        ...state,
        deleteDocumentLoading: false,
        deleteDocumentError: action.payload,
      };

    // Clear States
    case RAG_ACTION_TYPES.CLEAR_RAG_DATA:
      return {
        ...initialState,
      };
    case RAG_ACTION_TYPES.CLEAR_RAG_ERROR:
      return {
        ...state,
        processDocumentError: null,
        queryRAGError: null,
        getDocumentError: null,
        listDocumentsError: null,
        getDocumentChunksError: null,
        getRAGStatsError: null,
        updateDocumentError: null,
        deleteDocumentError: null,
      };

    default:
      return state;
  }
};

export default ragReducer;

